import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import _ from 'lodash'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PortalDynamicLink from '../portal-dynamic-link/PortalDynamicLink'

const PortalHeader = ({ portalID, title, townRefs, language, user }) => {
  const isShowBreadcrumb = portalID
  const headerTitle = _.get(title, language)
    ? _.toUpper(_.get(title, language))
    : 'NO PORTAL HEADER'

  return (
    <div className="section">
      <h1 className="title">
        {`${headerTitle}[${_.upperCase(language)}]`}
        <div className="tags">
          {_.map(townRefs, townRef => {
            return (
              <span key={townRef} className="tag">
                {townRef}
              </span>
            )
          })}
        </div>
      </h1>
      <PortalDynamicLink hostRef={portalID} />

      {isShowBreadcrumb && (
        <div className="is-pulled-right">
          <Breadcrumb user={user} />
        </div>
      )}
    </div>
  )
}

const Breadcrumb = withRouter(({ match, user }) => {
  const { t } = useTranslation()
  return (
    <nav className="breadcrumb is-right" aria-label="breadcrumbs">
      <ul>
        <li
          className={classNames({
            'is-active': _.includes(match.path, 'info'),
          })}
        >
          <Link to={`info`}>{t('info.label')}</Link>
        </li>
        <li
          className={classNames({
            'is-active': _.includes(match.path, 'image-management'),
          })}
        >
          <Link to={`image-management`}>{t('imageManagement.label')}</Link>
        </li>

        {!_.isEmpty(user.availableTowns) && (
          <li
            className={classNames({
              'is-active': _.includes(match.path, 'export'),
            })}
          >
            <Link to={`export`}>{t('export.label')}</Link>
          </li>
        )}
      </ul>
    </nav>
  )
})

export default connect(
  ({ portal: { title, townRefs }, info: { language }, auth }) => ({
    user: auth.user,
    title,
    townRefs,
    language,
  }),
)(PortalHeader)



// WEBPACK FOOTER //
// ./src/components/templates/navbar/PortalHeader.js